/**
 * Dev-Modus Produktions-Simulation.
 * Tickt jede Sekunde: addiert Fabrik-Output (×Energie-Modifier) zum Lager.
 */
import type { PlanetInfo } from '../world/PlayerWorldTypes';
import type { BuildingType } from '../config/BuildingTypes';
import { BUILDING_DEFS } from '../config/BuildingsConfig';
import { factoryProduction, storageCapacity } from './BuildingFormulas';
import { calcEnergyBalance } from './EnergyBalance';
import { updateHubHeader } from '../ui/PlanetHubHeader';

const TICK_MS = 1000;

const FACTORY_RES: { factory: BuildingType; storage: BuildingType;
  key: 'feronium' | 'chrysalium' | 'neurogel' }[] = [
  { factory: 'feronium_mine', storage: 'feronium_storage', key: 'feronium' },
  { factory: 'chrysalium_burner', storage: 'chrysalium_storage', key: 'chrysalium' },
  { factory: 'neurogel_extractor', storage: 'neurogel_tank', key: 'neurogel' },
];

export class DevProductionTick {
  private _timer: ReturnType<typeof setInterval> | null = null;
  private _planet: PlanetInfo | null = null;
  private _levels: Map<BuildingType, number> | null = null;
  private _headerEl: HTMLDivElement | null = null;

  start(
    planet: PlanetInfo,
    levels: Map<BuildingType, number>,
    headerEl: HTMLDivElement | null,
  ): void {
    this.stop();
    this._planet = planet;
    this._levels = levels;
    this._headerEl = headerEl;
    this._timer = setInterval(() => this._tick(), TICK_MS);
  }

  stop(): void {
    if (this._timer) { clearInterval(this._timer); this._timer = null; }
    this._planet = null;
    this._levels = null;
  }

  private _tick(): void {
    const p = this._planet;
    const levels = this._levels;
    if (!p || !levels) return;

    const energy = calcEnergyBalance(levels);

    for (const r of FACTORY_RES) {
      const lv = levels.get(r.factory) ?? 0;
      if (lv <= 0) continue;
      const prod = factoryProduction(lv, BUILDING_DEFS[r.factory].baseRate) * energy.modifier;
      if (prod <= 0) continue;

      const sLv = levels.get(r.storage) ?? 0;
      const cap = storageCapacity(sLv, BUILDING_DEFS[r.storage].baseRate);
      p[r.key] = Math.min(p[r.key] + prod, cap);
    }

    if (this._headerEl) {
      updateHubHeader(this._headerEl, p, levels, energy, true);
    }
  }
}
